/**
 * Pre-order functionality for Shopify Dawn theme
 * 
 * This file handles all dynamic pre-order updates when variants change.
 * It subscribes to Dawn's variant change events and updates:
 * - Button text (Pre-order vs Add to Cart)
 * - Button styling
 * - Dynamic checkout visibility
 * - Pre-order messaging visibility
 * - Pickup availability visibility
 * 
 * CUSTOMIZATION FILE - Safe from Dawn updates
 */

(function() {
  'use strict';

  // Wait for DOM and Dawn's pubsub to be ready
  function init() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      // Dawn's pubsub not ready yet, retry
      setTimeout(init, 100);
      return;
    }

    // Subscribe to variant changes
    subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
  }

  function handleVariantChange({ data }) {
    const { sectionId, html, variant } = data;
    if (!html || !variant) return;

    // Get source elements from the fetched HTML
    const sourceSubmitButton = html.getElementById(`ProductSubmitButton-${sectionId}`);
    const sourcePreorderMessaging = html.getElementById(`PreorderMessaging-${sectionId}`);
    const sourceDynamicCheckout = html.getElementById(`DynamicCheckout-${sectionId}`);
    const sourcePickupAvailability = html.querySelector('pickup-availability');

    // Get destination elements in the current DOM
    const destSubmitButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const destPreorderMessaging = document.getElementById(`PreorderMessaging-${sectionId}`);
    const destDynamicCheckout = document.getElementById(`DynamicCheckout-${sectionId}`);
    const destPickupAvailability = document.querySelector(`product-info[data-section="${sectionId}"] pickup-availability`);

    // Update pre-order messaging
    if (sourcePreorderMessaging && destPreorderMessaging) {
      destPreorderMessaging.innerHTML = sourcePreorderMessaging.innerHTML;
      destPreorderMessaging.classList.toggle('hidden', sourcePreorderMessaging.classList.contains('hidden'));
    }

    // Update dynamic checkout
    if (sourceDynamicCheckout && destDynamicCheckout) {
      destDynamicCheckout.innerHTML = sourceDynamicCheckout.innerHTML;
      destDynamicCheckout.classList.toggle('hidden', sourceDynamicCheckout.classList.contains('hidden'));
    }

    // Update button styling
    if (sourceSubmitButton && destSubmitButton) {
      const isPreorder = sourceSubmitButton.classList.contains('button--preorder');
      destSubmitButton.classList.toggle('button--preorder', isPreorder);
      
      // Update primary/secondary based on dynamic checkout visibility
      const showDynamicCheckout = sourceDynamicCheckout && !sourceDynamicCheckout.classList.contains('hidden');
      destSubmitButton.classList.toggle('button--primary', isPreorder || !showDynamicCheckout);
      destSubmitButton.classList.toggle('button--secondary', !isPreorder && showDynamicCheckout);
    }

    // Update pickup availability
    if (destPickupAvailability) {
      const isPreorder = sourcePickupAvailability?.dataset?.isPreorder === 'true';
      destPickupAvailability.classList.toggle('hidden', isPreorder);
      if (sourcePickupAvailability) {
        destPickupAvailability.dataset.isPreorder = sourcePickupAvailability.dataset.isPreorder || 'false';
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
